import { Capacitor } from '@capacitor/core';

/**
 * Ensure the Android notification channels the Admin Portal targets exist
 * on this device. The Admin Portal's `send-push` edge function sends
 * messages with `android.notification.channel_id = "admin-alerts"` for
 * operational pushes (booking/dispatch/system alerts). On Android 8+ a
 * notification targeting a non-existent channel is silently dropped, so
 * this channel MUST exist before any push from Admin is received.
 *
 * Idempotent — safe to call on every app start and every login.
 * No-op on web / iOS.
 */
export async function ensureAdminAlertsChannel(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;
  if (Capacitor.getPlatform() !== 'android') return;
  try {
    const { PushNotifications } = await import('@capacitor/push-notifications');
    await PushNotifications.createChannel({
      id: 'admin-alerts',
      name: 'Trip & Operational Alerts',
      description: 'Booking, trip lifecycle and operational alerts',
      importance: 5, // IMPORTANCE_HIGH — heads-up
      visibility: 1,
      lights: true,
      vibration: true,
      sound: 'default',
    });
  } catch (err) {
    console.warn('[push] ensureAdminAlertsChannel failed', err);
  }
}